"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
function selectSuscription(suscriptionsDocuments) {
    if (suscriptionsDocuments.empty) {
        return null;
    }
    let documentSuscription;
    suscriptionsDocuments.forEach(suscriptionDocument => {
        documentSuscription = {
            id: suscriptionDocument.id,
            ...suscriptionDocument.data()
        };
    });
    return documentSuscription;
}
/** Trae una suscripción de parametros con cierto id
 *
 */
function useSuscriptionIdInfo(firestore, suscriptionIdInfoData, queryOptions) {
    const planInfoCollection = (0, firestore_2.collection)(firestore, `parametros/${suscriptionIdInfoData.country}/subscription`);
    const planInfoQuery = (0, firestore_2.query)(planInfoCollection, (0, firestore_2.where)("mpPlanId", "==", suscriptionIdInfoData.id));
    return (0, firestore_1.useFirestoreQuery)(keyFactory_1.FirestoreKeys.Suscription({
        name: "suscriptionIdInfo",
        path: `parametros/${suscriptionIdInfoData.country}/subscription`
    }, [suscriptionIdInfoData.country, suscriptionIdInfoData.id]), planInfoQuery, {}, {
        ...queryOptions,
        select: (suscriptionsDocuments) => {
            const selectSuscriptionWithId = selectSuscription(suscriptionsDocuments);
            if (queryOptions?.select) {
                return queryOptions.select(selectSuscriptionWithId);
            }
            return selectSuscriptionWithId;
        }
    });
}
exports.default = useSuscriptionIdInfo;
